import { max, round, sortBy } from 'lodash';

const getFormattedPrice = (p, ix, all, formatter) => {
  if (ix === 0) {
    return `${formatter(0)} - ${formatter(p)}`;
  }

  if (ix > 0 && ix < all.length - 1) {
    return `${formatter(all[ix - 1])} - ${formatter(p)}`;
  }

  return `${formatter(p)}+`;
};

const getPricePoints = (products, formatter) => {
  const prices = sortBy(
    products
      .filter(({ shopifyProduct }) => !!shopifyProduct)
      .map(
        ({
          shopifyProduct: {
            priceRangeV2: {
              minVariantPrice: { amount },
            },
          },
        }) => parseFloat(amount)
      )
  );

  const priceMax = max(prices);

  return [0.2, 0.4, 0.6, 0.8]
    .map(n => round(priceMax * n))
    .map((point, ix, all) => {
      let range = [all[ix - 1], point];
      if (ix === 0) {
        range = [0, point];
      }
      if (ix === all.length - 1) {
        range = [point];
      }
      return {
        point,
        range,
        tag: `${point}`,
        title: getFormattedPrice(point, ix, all, formatter),
      };
    })
    .filter(p =>
      products.some(({ shopifyProduct }) => {
        const { amount } = shopifyProduct.priceRangeV2.minVariantPrice;

        return (
          amount >= p.range[0] && (p.range[1] ? amount <= p.range[1] : true)
        );
      })
    );
};

export { getFormattedPrice, getPricePoints };
